'use client'
import { tv } from 'tailwind-variants'

import { DestinationType } from '_/services/destinations/destination.scheme'
import { Breadcrumbs } from '_/ui/breadcrumbs'
import Image from 'next/image'

const FormsStyles = tv({
	slots: {
		root: 'flex flex-col w-full',
		breadcrumb: 'flex flex-row text-base font-bold !text-primary-neutral flex-wrap py-6',
		main: 'flex flex-col overflow-hidden h-auto relative pb-[70px] mb-6 bg-white rounded-lg',
		header: 'flex flex-col bg-primary-neutral pt-10 mb-[70px] px-8 xl:px-[6.375rem]',
		headerWrapper: 'flex flex-row px-0 mx-auto relative',
	},
})

type FormProps = {
	destination?: DestinationType
	children: React.ReactNode
}

const breadcrumbItems = [
	{ label: 'Destinations', href: '/destinations' },
	{ label: 'Request a Quote', href: '#' },
]

export default function Form({ destination, children }: FormProps) {
	const { root, breadcrumb, header, headerWrapper, main } = FormsStyles()

	if (!destination) {
		return null
	}

	const destinationData = destination.attributes
	const destinationImage = destinationData.heroImage?.data?.attributes.url
	const themeAttr = destinationData.themes.data.attributes

	return (
		<main className={root()}>
			<Breadcrumbs className={breadcrumb()} items={breadcrumbItems} />
			<section className={main()}>
				<section className={header()}>
					<div className={headerWrapper()}>
						<div className='relative h-full max-w-[160px]'>
							<Image
								src='/imgs/request-quote/header-left.png'
								height={250}
								width={250}
								alt=''
								className='absolute right-[-80px] -top-[80px] z-0 opacity-20 md:opacity-100 w-[calc(100%+90px)] h-auto min-w-[240px] max-h-[240px]'
								loading='lazy'
							/>
						</div>
						<div className='flex flex-col w-full min-w-[80vw] lg:min-w-[700px] xl:min-w-[820px]'>
							<div>
								<h1 className='text-2xl mt-2 mx-auto font-bold text-gray-100 text-center'>
									Request a free, no obligation quote for {destinationData.title}
								</h1>
								<h3 className='text-base mx-auto text-gray-100 mt-3 text-center'>
									Let’s plan your next stress-free trip.
								</h3>
							</div>
							<figure className='h-full min-h-[17.75rem] lg:min-h-[18.75rem] w-full px-0 rounded-xl mt-6 md:mt-12 mb-[-2.5rem] md:mb-[-4.375rem] z-10 max-h-36'>
								<Image
									src={destinationImage ? destinationImage : `/imgs/request-quote/${themeAttr.slug}.png`}
									height={140}
									width={820}
									alt=''
									className='object-cover w-full h-full rounded-xl'
									loading='lazy'
								/>
							</figure>
						</div>
						<div className='relative h-full max-w-[160px]'>
							<Image
								src='/imgs/request-quote/header-right.png'
								height={250}
								width={250}
								alt=''
								className='absolute left-[-80px] -top-[80px] z-20 opacity-20 md:opacity-100 w-[calc(100%+90px)] h-auto min-w-[240px] max-h-[240px]'
								loading='lazy'
							/>
						</div>
					</div>
				</section>
				<section>{children}</section>
			</section>
		</main>
	)
}
